import PropTypes from "prop-types";

// formik components
import { ErrorMessage, Field } from "formik";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { useCallback } from "react";

export default function FormField({ label, name, mask, fieldShrink, ...rest }) {
  const handleKey = useCallback((e) => {
    let value = e.target.value;
    switch (mask) {
      // 99.999.999/9999-99
      case "CNPJ":
        e.target.maxLength = 18;
        value = value.replace(/\D/g, "");
        value = value.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/,
          "$1.$2.$3/$4-$5"
        );
        break;

      // 99.999-999
      case "CEP":
        e.target.maxLength = 9;
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{2})(\d{3})(\d)/, "$1$2-$3");
        break;

      // 999.999.999-99
      case "CPF":
        e.target.maxLength = 14;
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4");
        break;

      // (99) 99999-9999
      case "phoneBR":
        e.target.maxLength = 15;
        value = value.replace(/\D/g, "");
        value =
          value.length < 11
            ? value.replace(/^(\d{2})(\d{4})(\d)/g, "($1) $2-$3")
            : value.replace(/^(\d{2})(\d{5})(\d)/g, "($1) $2-$3");
        break;

      // 99/99/9999
      case "date":
        e.target.maxLength = 10;
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{2})(\d{2})(\d)/, "$1/$2/$3");
        break;

      case "money":
        let time = 0;
        if (time === 0) {
          if (value) {

            let valueAfterDecimal;
            if (value.indexOf("R$") !== -1) {
              const valueWithoutPrefix = value.replace("R$", "");
              valueAfterDecimal = valueWithoutPrefix.split(",");
            } else {
              valueAfterDecimal = value.split(",");
            }

            const valueWithoutCommas = valueAfterDecimal[0].replaceAll(".", "");
            const letters = valueWithoutCommas.split("");
            let word = "";
            let number = 0;
            let count = 0;

            if (letters.length === (3 || 6 || 9 || 12 || 15 || 18 || 21)) {
              for (const lett of letters) {
                number = number + 1;
                if (number === 3) {
                  word = `${word}.`;
                  number = 0;
                }
                word = `${word}${lett}`;
              }
            } else if (
              letters.length === (1 || 4 || 7 || 10 || 13 || 16 || 19)
            ) {

              for (const lett of letters) {
                if (count === 0) {
                  count = count + 1;
                  word = `${word}${lett}`;
                } else {
                  if (number === 3) {
                    word = `${word}.`;
                    number = 0;
                    word = `${word}${lett}`;
                  }
                }
              }
            } else if (
              letters.length === (2 || 5 || 8 || 11 || 14 || 17 || 20)
            ) {

              for (const lett of letters) {
                if (count <= 1) {
                  count = count + 1;
                  word = `${word}${lett}`;
                } else {
                  if (number === 3) {
                    word = `${word}.`;
                    number = 0;
                    word = `${word}${lett}`;
                  }
                }
              }
            }
            if (valueAfterDecimal.length === 2) {
              value = `R$${word},${valueAfterDecimal[1]}`;
            } else if (valueAfterDecimal[0] === "") {
              value = ``;
            } else {
              value = `R$${word}`;
            }
          }
          time = time + 1;
        }
        break;

      default:
        break;
    }
    e.target.value = value;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBox mb={1.5}>
      <Field
        {...rest}
        name={name}
        as={MDInput}
        variant="standard"
        label={label}
        fullWidth
        onKeyUp={handleKey}
        onKeyDown={handleKey}
        onKeyPress={handleKey}
        InputLabelProps={fieldShrink ? { shrink: fieldShrink } : null}
      />
      <MDBox mt={0.75}>
        <MDTypography
          component="div"
          variant="caption"
          color="error"
          fontWeight="regular"
        >
          <ErrorMessage name={name} />
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
